import React from "react";
import "./App.scss";
import Main from "./Router.App";
const host = window.location.hostname
  .replace(/www\./g, '')
  .replace(/amp\./g, '')
  .replace(/\.es/, '')
  .replace(/\.com/, '')
  .replace('localhost', 'lasexta');

// Rediseño sites have subdomain removed from its document domain, replace properly to allow parent navigation
if (document.location.hash.indexOf("amp") === -1) {
  document.domain = document.domain.replace("www.", "");
}

export const App = ({ entry }) => (
  <div className={`App ${host}`}>
    <Main entry={entry} />
  </div>
);

export default App;
